import { values } from '@fortem-monorepo/js-utilities';
export const LISTING_VENUE = {
    EuroMtf: 'Euro MTF',
    EuroMtfLuxembourg: 'Euro MTF, Luxembourg',
    LuxembourgMtf: 'Luxembourg MTF',
    GlobalExchangeMarketIreland: 'Global Exchange Market, Ireland',
};
export const LISTING_VENUES = values(LISTING_VENUE);
